import { Injectable } from '@angular/core';
import { environment } from '@env/environment';

interface Scripts {
  name: string;
  src?: string;
  type?: string;
}
export const ScriptStore: Scripts[] = [
  { name: 'jszip', src: 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.6.0/jszip.js' },
  { name: 'xlsx', src: 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.16.8/xlsx.min.js' },
  { name: 'moment', src: 'https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.24.0/moment.min.js' },
  { name: 'jsPDF', type: "module", src: 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js' },
  { name: 'html2canvas', src: 'https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js' },
  { name: 'pdfjs', src: 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js' },
  { name: 'new-relic-staging', src: 'assets/js/staging/new-relic.js' },
  { name: 'new-relic-demo', src: 'assets/js/demo/new-relic.js' },
  { name: 'new-relic-prod', src: 'assets/js/prod/new-relic.js' },
  { name: 'mammoth', src: 'https://cdnjs.cloudflare.com/ajax/libs/mammoth/1.4.21/mammoth.browser.js' },
  { name: 'gtm' },
  { name: 'xlsx-full', src: 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.16.8/xlsx.full.min.js' }
];

@Injectable({
  providedIn: 'root'
})
export class LoadExternalScriptService {
  private scripts: any = {};

  constructor() {
    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src
      };
    });
  }

  load(...scripts: string[]) {
    const promises: any[] = [];
    scripts.forEach((script) => promises.push(this.loadScript(script)));
    return Promise.all(promises);
  }

  loadScript(name: string) {
    return new Promise((resolve, reject) => {
      // resolve if already loaded
      if (this.scripts[name].loaded) {
        resolve({ script: name, loaded: true, status: 'Already Loaded' });
      } else {
        // load script
        const script = document.createElement('script');
        if (name === 'gtm') {
          if (environment.environmentName === 'Prod') {
            script.innerHTML = `function (w, d, s, l, i) {
              w[l] = w[l] || []; w[l].push({
                'gtm.start':
                  new Date().getTime(), event: 'gtm.js'
              }); var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                  'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', 'GTM-P7C5BCV');`;
          } else {
            script.innerHTML = `(function (w, d, s, l, i) {
              w[l] = w[l] || []; w[l].push({
                'gtm.start':
                  new Date().getTime(), event: 'gtm.js'
              }); var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                  'https://www.googletagmanager.com/gtm.js?id=' + i + dl + '&gtm_auth=YS3JSt2rEVl7-V_f3ZAYCw&gtm_preview=env-4&gtm_cookies_win=x'; f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', 'GTM-P7C5BCV');`;
          }
        } else {
          script.type = this.scripts[name].type ? this.scripts[name].type : 'text/javascript';
          script.src = this.scripts[name].src;
        }
        script.onload = () => {
          this.scripts[name].loaded = true;
          resolve({ script: name, loaded: true, status: 'Loaded' });
        };
        script.onerror = (error: any) => resolve({ script: name, loaded: false, status: 'Loaded' });
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    });
  }
}
